/**
 * Academy domain — `AcademyCapabilitiesStore` state shape. Remote-only, in-memory.
 * `capabilities` stays `null` until `GET /Capabilities/me` answers, so every
 * capability reads as "not allowed" while the request is pending or failed.
 */
import type { CapabilitiesResponse } from './academy-capabilities.model';

export interface AcademyCapabilitiesState {
  /** Last `GET /Capabilities/me` answer for this session. */
  capabilities: CapabilitiesResponse | null;
  /**
   * `true` once the first load answered, success or failure, and never reset in the
   * session. A retry does not flip it back, so a screen that builds something from
   * the producer decision keeps it while the retry is in flight.
   */
  capabilitiesSettled: boolean;
  /**
   * `true` after a failure was shown to the user, until the next success. Retries
   * of the same outage fail silently instead of stacking one toast per screen.
   */
  capabilitiesErrorReported: boolean;
}

export const initialAcademyCapabilitiesState: AcademyCapabilitiesState = {
  capabilities: null,
  capabilitiesSettled: false,
  capabilitiesErrorReported: false,
};
